<template>
  <div class="content">
    <div class="succeed-box">
      <img :src="require('../../assets/'+appTheme+'/succeed.png')" alt="" />
      <div class="succeed-box-content">
        <div class="succeed-hint">恭喜您，支付成功</div>
        <div class="go-index" @click="goIndex">返回商城</div>
        <!--        <div class="hint">以上的订单内容由商家提供 <span>投诉</span></div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "paySucceed",
  data(){
    return{
      appTheme:this.$store.state.appTheme,
    }
  },
  created() {
    var mchData = {action: 'onIframeReady', displayStyle: 'SHOW_CUSTOM_PAGE'}
    var postData = JSON.stringify(mchData)
    parent.postMessage(postData, 'https://payapp.weixin.qq.com')
  },
  methods: {
    getQueryString(name) {
      var query = window.location.search.substring(1);
      var vars = query.split("&")

      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == name) {
          return pair[1]
        }
      }
      return null
    },
    goIndex(){
      var out_trade_no = this.getQueryString("out_trade_no");
      var mchData = {
        action: 'jumpOut',
        jumpOutUrl: 'https://jpzs.itos.cn/Wechat/Index/index.html?out_trade_no=' + out_trade_no
      }
      var postData = JSON.stringify(mchData)
      parent.postMessage(postData, 'https://payapp.weixin.qq.com')

      // this.$router.push('/');

    }
  }
}
</script>

<style lang="scss" scoped>
.succeed-box{
  background: #ffffff;position: relative;
  img{
    width: 100%;height: auto;display: block;
  }
  .succeed-box-content{
    position: absolute;left: 0;top: 450px;width: 100%;
    .succeed-hint{
      font-weight: bold;
      color: #55BB3A;font-size: 38px;
    }
    .go-index{
      padding: 20px 0;font-size: 32px;color: #282828;font-weight: bold;
      background: #FDD80D;
      border-radius: 42px;width: 424px;margin: 80px auto 0;
    }
    .hint{
      font-size: 20px;font-weight: 400;
      color: #BCBCBC;margin-top: 184px;
    }
  }
}
</style>
